<template>
  <div class="page-home">
    <div class="pg-breadcrumb">
      <div class="breadcrumb-item em">統計圖表</div>
    </div>

    <div class="pg-block">
      <Spin fix class="pg-sub-loading" v-if="isLoading">
        <Icon type="ios-loading" :size="20" class="demo-spin-icon-load"></Icon>
        <div class="loading-text">Loading</div>
      </Spin>
      <div :class="[isLoading ? 'ov' : '']">
        <Form inline class="pg-form-inline">
          <FormItem>
            <Select
              size="small"
              placeholder="提貨櫃點"
              v-model="form.arrive"
              filterable
              clearable
            >
              <Option
                :value="item.ReceivingID"
                v-for="(item, index) in pickAddress"
                :key="item.ReceivingID"
              >
                ({{ item.cainiao_match }}) {{ item.ReceivingName }}
              </Option>
            </Select>
          </FormItem>
          <FormItem>
            <Select
              size="small"
              placeholder="包裹类型"
              v-model="form.packageType"
              filterable
              clearable
            >
              <Option value=""> 全部 </Option>
              <Option value="jyb"> 集运帮 </Option>
              <Option value="pdd"> 拼多多 </Option>
            </Select>
          </FormItem>
          <FormItem>
            <div class="hd-item">
              <div class="pg-btn-wrap">
                <em class="red">* </em>
                <span class="date-space"> 從 </span>
                <DatePicker
                  type="date"
                  class="date-filter"
                  size="small"
                  placeholder="起始日期"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.start_time"
                ></DatePicker>
                <em class="red">* </em>
                <span class="date-space"> 到 </span>
                <DatePicker
                  type="date"
                  class="date-filter"
                  size="small"
                  placeholder="結束日期"
                  :clearable="false"
                  value-format="yyyy-MM-dd"
                  v-model="form.end_time"
                  style="margin-right: 15px"
                ></DatePicker>
                <div class="pg-btn style1" @click="handleSearch()">搜索</div>
              </div>
            </div>
          </FormItem>
        </Form>

        <div class="chart-box" v-for="(item, index) in list" :key="index">
          <div class="box-header">
            <div class="hd-item">
              <div class="title">{{ item.titles }}</div>
            </div>
            <div class="hd-item">
              <div class="chart-legend">
                <span class="circle style1"></span>
                <span>{{ item.putInStorage }}</span>
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="
                    item.titles == '珠海倉庫' && item.putInStorage == '待出庫'
                  "
                  >{{ counts }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="
                    item.titles == '澳門門店' && item.putInStorage == '未簽收'
                  "
                  >{{ counts3 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="
                    item.titles == '澳門倉庫' && item.putInStorage == '已入庫'
                  "
                  >{{ counts5 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="
                    item.titles == '智能櫃' && item.putInStorage == '未簽收'
                  "
                  >{{ counts7 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="item.titles == '門店/智能櫃-快遞統計'"
                  >{{ counts9 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="item.titles == '全局-快遞統計'"
                  >{{ counts10 }}</span
                >
              </div>
              <div class="chart-legend" v-if="item.outBound != null">
                <span class="circle style2"></span>
                <span>{{ item.outBound }}</span>
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="item.titles == '珠海倉庫' && item.outBound == '已出庫'"
                  >{{ counts2 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="item.titles == '澳門門店' && item.outBound == '已簽收'"
                  >{{ counts4 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="item.titles == '澳門倉庫' && item.outBound == '已出庫'"
                  >{{ counts6 }}</span
                >
                <span
                  style="font-size: 16px; font-weight: bold; margin-left: 10px"
                  v-if="item.titles == '智能櫃' && item.outBound == '已簽收'"
                  >{{ counts8 }}</span
                >
              </div>
            </div>
          </div>
          <div class="box-cont">
            <div :id="'chart' + (index + 1)" style="height: 100%"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Store from "../../../assets/js/store.js";

export default {
  name: "Home",
  data() {
    return {
      isLoading: false,
      tempArr: [],
      tempArr1: [],
      tempArr2: [],
      tempArr_DataStore: [],
      tempArr_count_goods: [],
      tempArr5: [],
      pickAddress: [],
      form: {
        start_time: "",
        end_time: "",
        // arrive: Store.fetch().store_id,
        arrive: "",
        packageType: "",
      },
      list: [
        {
          titles: "珠海倉庫",
          putInStorage: "待出庫",
          outBound: "已出庫",
          xData: [],
          yData: [],
          chartIns: "",
        },
        {
          titles: "澳門倉庫",
          putInStorage: "已入庫",
          outBound: "已出庫",
          xData: [],
          yData: [],
        },
        {
          titles: "澳門門店",
          putInStorage: "未簽收",
          outBound: "已簽收",
          xData: [],
          yData: [],
        },
        {
          titles: "智能櫃",
          putInStorage: "未簽收",
          outBound: "已簽收",
          xData: [],
          yData: [],
        },
        {
          titles: "門店/智能櫃-快遞統計",
          putInStorage: "上架量",
          xData: [],
          yData: [],
        },
        {
          titles: "全局-快遞統計",
          putInStorage: "上架量",
          xData: [],
          yData: [],
        },
      ],
      counts: 0,
      counts2: 0,
      counts3: 0,
      counts4: 0,
      counts5: 0,
      counts6: 0,
      counts7: 0,
      counts8: 0,
      counts9: 0,
      counts10: 0,
    };
  },
  created() {
    this.getPickAddress();
  },
  mounted() {
    // this.handleSearch('init')
  },
  methods: {
    //提貨櫃點
    getPickAddress() {
      this.$Rq
        .requestAuth({
          url: this.$Api.pickAddress,
          method: "get",
          data: {
            company_id: 0,
          },
        })
        .then((res) => {
          if (res.code == 0) {
            this.pickAddress = res.data.data.filter(
              (it) => it.company_id != 15
            );
          }
        });
    },
    async initLineChart(index, api) {
      this.counts = 0;
      this.counts2 = 0;
      this.counts3 = 0;
      this.counts4 = 0;
      this.counts5 = 0;
      this.counts6 = 0;
      this.counts7 = 0;
      this.counts8 = 0;

      let form = this.form;
      const res = await this.$Rq.requestAuth({
        url: api,
        method: "get",
        data: {
          start_time: this.$Utils.formatDate(form.start_time),
          end_time: this.$Utils.formatDate(form.end_time),
          arrive: this.form.arrive || "",
          packageType: this.form.packageType || "",
        },
      });

      if (res.code == 0) {
        let tempArr = [];
        let tempArr1 = [];
        let tempArr2 = [];
        let counts = 0;
        let counts2 = 0;
        let counts3 = 0;
        let counts4 = 0;
        let counts5 = 0;
        let counts6 = 0;
        let counts7 = 0;
        let counts8 = 0;
        let resData = res.data;

        for (let i = 0; i < resData.length; i++) {
          tempArr.push(resData[i].in_day);
          tempArr1.push(resData[i].in_count);
          tempArr2.push(resData[i].out_count);
          if (index === 1) {
            counts += resData[i].in_count;
            counts2 += resData[i].out_count;
          } else if (index === 3) {
            //in_count  out_count
            counts3 += resData[i].in_count;
            counts4 += resData[i].out_count;
          } else if (index === 2) {
            //in_count  out_count
            counts5 += resData[i].in_count;
            counts6 += resData[i].out_count;
          } else if (index === 4) {
            //in_count  out_count
            counts7 += resData[i].in_count;
            counts8 += resData[i].out_count;
          }
        }
        let xData = tempArr;
        let yDataRed = tempArr1;
        let yDataRedMax = this.list[index - 1].yData.yDataRedMax;
        let yDataBlue = tempArr2;
        let putInStorage = this.list[index - 1].putInStorage;
        let outBound = this.list[index - 1].outBound;
        if (index === 1) {
          this.counts = counts;
          this.counts2 = counts2;
        } else if (index === 3) {
          //in_count  out_count
          this.counts3 = counts3;
          this.counts4 = counts4;
        } else if (index === 2) {
          //in_count  out_count
          this.counts5 = counts5;
          this.counts6 = counts6;
        } else if (index === 4) {
          //in_count  out_count
          this.counts7 = counts7;
          this.counts8 = counts8;
        }

        this["chartIns" + index] = this.$echarts.init(
          document.getElementById("chart" + index)
        );
        let option = {
          title: {
            show: res.data.length === 0,
            extStyle: {
              color: "grey",
              fontSize: 20,
            },
            text: "暫無數據",
            left: "center",
            top: "center",
          },
          grid: {
            left: "0",
            right: "0",
            top: "2%",
            bottom: "2%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              axisLabel: {
                color: "#333",
                interval:
                  index != 6 && xData.length > 300
                    ? 30
                    : index != 6 && xData.length > 180
                    ? 20
                    : index != 6 && xData.length > 60
                    ? 10
                    : null,
                rotate: 50,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#ccc",
                },
              },
              axisTick: {
                show: true,
              },
              splitLine: {
                show: true,
              },
              data: xData,
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              max: function (value) {
                let result = Math.ceil(value.max / 100) * 100 + 100;
                if (yDataRedMax < 200) {
                  result = Math.ceil(value.max / 10) * 10 + 50;
                }
                return result;
              },
              nameLocation: "end",
              axisLabel: {
                formatter: "{value}",
                textStyle: {
                  color: "#999",
                },
              },
              axisLine: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#ccc",
                  type: "dashed",
                },
              },
            },
          ],
          series: [
            {
              name: putInStorage,
              type: "line",
              symbol: "emptyCircle",
              symbolSize: 6,
              hoverAnimation: true,
              label: {
                show: true,
                position: "top",
                /* formatter: function(param)
                {
                    var rate = param.data / yDataRedMax * 100;
                    var decimal = /\./g.test(('' + rate).toString());
                    if(decimal)
                    {
                        rate = rate.toFixed(1);
                    }
                    return param.data + '\n' + rate + '%'
                } */
              },
              itemStyle: {
                color: "#FF6565",
                borderWidth: 2,
              },
              lineStyle: {
                color: "#FF6565",
                width: 2,
              },
              data: yDataRed,
            },
            {
              name: outBound,
              type: "line",
              symbol: "emptyCircle",
              symbolSize: 6,
              hoverAnimation: true,
              label: {
                show: true,
                position: "bottom",
                // formatter: function(param)
                // {
                //     var rate = param.data / yDataRed[param.dataIndex] * 100;
                //     var decimal = /\./g.test(('' + rate).toString());
                //     if(decimal)
                //     {
                //         rate = rate.toFixed(1);
                //     }
                //     return param.data + '\n' + rate + '%'
                // }
              },
              itemStyle: {
                color: "#6584FF",
                borderWidth: 2,
              },
              lineStyle: {
                color: "#6584FF",
                width: 2,
              },
              data: yDataBlue,
            },
          ],
          tooltip: [
            {
              show: true,
              trigger: "axis",
              axisPointer: {
                type: "shadow",
                label: {
                  backgroundColor: "#6a7985",
                  formatter: (params) => {
                    console.log(params);
                    let buerData =
                      (params.seriesData[1].data / params.seriesData[0].data) *
                      100;
                    var decimal = /\./g.test(("" + buerData).toString());
                    if (decimal) {
                      buerData = buerData.toFixed(1);
                    }
                    // let index1 = (params.seriesData[1].seriesName.indexOf('(')) + 1;
                    // let index2 = params.seriesData[1].seriesName.indexOf(')');
                    return (
                      params.value +
                      "-" +
                      params.seriesData[1].seriesName +
                      "成功率 " +
                      +buerData +
                      "%"
                    );
                  },
                },
              },
            },
          ],
        };
        this["chartIns" + index].setOption(option);
      }
    },

    async initLineChartStore(index, api) {
      this.counts9 = 0;
      this.counts10 = 0;
      let limit = index == 6 ? 100 : undefined;
      let form = this.form;
      const res = await this.$Rq.requestAuth({
        url: api,
        method: "get",
        data: {
          start_time: this.$Utils.formatDate(form.start_time),
          end_time: this.$Utils.formatDate(form.end_time),
          packageType: this.form.packageType || "",
          arrive: this.form.arrive || "",
          limit,
        },
      });

      if (res.code == 0) {
        let tempArr_DataStore = [];
        let tempArr_count_goods = [];
        let counts9 = 0;
        let counts10 = 0;
        let resDataStore = res.data.data;
        if (index == 6) {
          resDataStore.sort((a, b) => new Date(a.month) - new Date(b.month));
        }

        for (let i = 0; i < resDataStore.length; i++) {
          if (index === 5) {
            tempArr_DataStore.push(resDataStore[i].out_time_date);
            tempArr_count_goods.push(resDataStore[i].count_goods);
            counts9 += resDataStore[i].count_goods;
          } else if (index == 6) {
            tempArr_DataStore.push(resDataStore[i].month);
            tempArr_count_goods.push(resDataStore[i].record_count);
            counts10 = counts10 + resDataStore[i].record_count;
          } else {
            tempArr_DataStore.push(resDataStore[i].out_time_date);
            tempArr_count_goods.push(resDataStore[i].count_goods);
          }
        }

        let xData = tempArr_DataStore;
        let yDataRed = tempArr_count_goods;
        let yDataRedMax = this.list[index - 1].yData.yDataRedMax;
        let putInStorage = this.list[index - 1].putInStorage;
        if (index === 5) {
          this.counts9 = counts9;
        } else if (index === 6) {
          this.counts10 = counts10;
        }

        this["chartIns" + index] = this.$echarts.init(
          document.getElementById("chart" + index)
        );
        let option = {
          title: {
            show: resDataStore.length === 0,
            extStyle: {
              color: "black",
              fontSize: 20,
            },
            text: "暫無數據",
            left: "center",
            top: "center",
          },
          grid: {
            left: "0",
            right: "0",
            top: "2%",
            bottom: "2%",
            containLabel: true,
          },
          xAxis: [
            {
              type: "category",
              boundaryGap: true,
              axisLabel: {
                color: "#333",
                interval:
                  index != 6 && xData.length > 300
                    ? 30
                    : index != 6 && xData.length > 180
                    ? 20
                    : index != 6 && xData.length > 60
                    ? 10
                    : null,
                rotate: 50,
              },
              axisLine: {
                show: true,
                lineStyle: {
                  color: "#ccc",
                },
              },
              axisTick: {
                show: true,
              },
              splitLine: {
                show: true,
              },
              data: xData,
            },
          ],
          yAxis: [
            {
              type: "value",
              min: 0,
              max: function (value) {
                let result = Math.ceil(value.max / 100) * 100 + 100;
                if (yDataRedMax < 200) {
                  result = Math.ceil(value.max / 10) * 10 + 50;
                }
                return result;
              },
              nameLocation: "end",
              axisLabel: {
                formatter: "{value}",
                textStyle: {
                  color: "#999",
                },
              },
              axisLine: {
                show: true,
              },
              axisTick: {
                show: false,
              },
              splitLine: {
                show: true,
                lineStyle: {
                  color: "#ccc",
                  type: "dashed",
                },
              },
            },
          ],
          series: [
            {
              name: putInStorage,
              type: "line",
              symbol: "emptyCircle",
              symbolSize: 6,
              hoverAnimation: true,
              label: {
                show: true,
                position: "top",
              },
              itemStyle: {
                color: "#FF6565",
                borderWidth: 2,
              },
              lineStyle: {
                color: "#FF6565",
                width: 2,
              },
              data: yDataRed,
            },
          ],
        };
        this["chartIns" + index].setOption(option);
      }
    },
    handleSearch(type) {
      if (!type) {
        if (this.form.start_time === "") {
          this.$Utils.showTipInfo("請輸入起始時間");
          return;
        } else if (this.form.end_time === "") {
          this.$Utils.showTipInfo("請輸入結束時間");
          return;
        } else if (this.form.end_time < this.form.start_time) {
          this.$Utils.showTipInfo("起始時間不能大於結束時間");
          return;
        }
      }
      this.isLoading = true;
      Promise.all([
        this.initLineChart(1, this.$Api.home_zhuhai),
        this.initLineChart(2, this.$Api.home_macao_originating),
        this.initLineChart(3, this.$Api.home_macao_pickup),
        this.initLineChart(4, this.$Api.home_smartbox_pickup),
        this.initLineChartStore(5, this.$Api.home_views_daily_zhuhai_outtime),
        this.initLineChartStore(6, this.$Api.home_views_daily_outtime),
      ]).finally(() => {
        this.isLoading = false;
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.page-home {
  .ivu-input {
    font-size: 13px;
  }
}

.ov {
  max-height: calc(100vh - 180px);
  overflow-y: hidden;
}

@import "traffic.scss";
</style>
